import monitoring from './monitoring_layers';
import water_supply from './water_supply_layers';
import effluents from './effluents_layers';
import conservation from './conservation_layers';
import stations_data from './stations_data_layers';
import indicators from './indicators_layers';
import undergroundWater from './underground_water_layers';

export default {
  monitoring,
  water_supply,
  effluents,
  conservation,
  stations_data,
  indicators,
  undergroundWater,
};
